var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiversharesLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 51.002,
    viewBox: "0 0 292 51.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 292,
    height: 51.002,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6058",
    "data-name": "Group 6058",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6056",
    "data-name": "Group 6056",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M56.172,29.524A2.35,2.35,0,0,0,57.2,27.458V2.909A2.414,2.414,0,0,0,56.172.8h7.214a2.533,2.533,0,0,0-1.034,2.111V27.458a2.466,2.466,0,0,0,1.034,2.066Z",
    transform: "translate(-24.814 -0.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M104.591,2.072,92.41,31.242,79.842.8h3.286A3.425,3.425,0,0,1,86.273,2.86l7.464,18.068,7.957-18.956a1.523,1.523,0,0,0,.1-.442A1.009,1.009,0,0,0,101.447.8h4.127a2.5,2.5,0,0,0-.983,1.274",
    transform: "translate(-35.27 -0.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M133.745,29.524V2.909A2.514,2.514,0,0,0,132.517.8h18.024V5.41A3.529,3.529,0,0,0,146.908,3.3H138.9v10.12h7.468a1.959,1.959,0,0,0,1.668-.987V16.9a1.953,1.953,0,0,0-1.668-.984H138.9V27.065h9.087a3.85,3.85,0,0,0,3.68-2.013v4.472Z",
    transform: "translate(-58.54 -0.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M201.092,29.524a5.961,5.961,0,0,1-5.206-2.6L187.141,14.4H189.3a5.423,5.423,0,0,0,5.251-5.551,5.428,5.428,0,0,0-5.251-5.6h-4.566v24.2a2.4,2.4,0,0,0,1.032,2.066H178.55a2.4,2.4,0,0,0,1.032-2.066V2.909A2.457,2.457,0,0,0,178.55.8h12.126c5.8,0,9.774,3.531,9.774,7.66,0,3.238-2.6,6.286-6.043,7.367l9.631,13.7Z",
    transform: "translate(-78.875 -0.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M22.541,29.524a5.962,5.962,0,0,1-5.206-2.6L8.591,14.4h2.163A5.422,5.422,0,0,0,16,8.849a5.428,5.428,0,0,0-5.25-5.6H6.187v24.2a2.4,2.4,0,0,0,1.032,2.066H0a2.4,2.4,0,0,0,1.033-2.066V2.909A2.46,2.46,0,0,0,0,.8H12.126C17.92.8,21.9,4.329,21.9,8.458c0,3.238-2.6,6.286-6.042,7.367l9.63,13.7Z",
    transform: "translate(0 -0.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M297.22.8V12.179H285.55V.8h-6.329V29.56h6.329V18.014h11.67V29.56h6.328V.8Z",
    transform: "translate(-123.347 -0.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M339.3.429,326.969,29.4h6.45l2.63-6.452h12.163l2.63,6.452h6.615L345.131.429Zm2.836,7.6,3.821,9.327H338.31Z",
    transform: "translate(-144.439 -0.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M386.759.8h13.148c3.658,0,6.494,1.027,8.383,2.918a9.025,9.025,0,0,1,2.466,6.573v.083a8.933,8.933,0,0,1-6.164,8.916l7.026,10.272h-7.4l-6.163-9.2h-4.972v9.2h-6.328ZM399.5,14.767c3.082,0,4.848-1.644,4.848-4.068v-.082c0-2.712-1.89-4.108-4.972-4.108h-6.286v8.258Z",
    transform: "translate(-170.852 -0.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M438.276.8V29.56h21.9V23.93H444.562v-6.04h13.559V12.262H444.562V6.425h15.409V.8Z",
    transform: "translate(-193.609 -0.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M482.288,25.043l3.739-4.479a13.192,13.192,0,0,0,8.588,3.492c2.589,0,4.149-1.027,4.149-2.711v-.082c0-1.6-.986-2.424-5.792-3.658-5.794-1.479-9.534-3.082-9.534-8.792V8.731c0-5.219,4.192-8.67,10.067-8.67a16.647,16.647,0,0,1,10.684,3.657L500.9,8.484a13.5,13.5,0,0,0-7.478-2.836c-2.424,0-3.7,1.11-3.7,2.507v.082c0,1.891,1.234,2.507,6.2,3.781,5.836,1.52,9.122,3.616,9.122,8.628v.082c0,5.712-4.355,8.918-10.56,8.918a18.306,18.306,0,0,1-12.2-4.6",
    transform: "translate(-213.052 -0.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M252.652,32.149c-.051.094-.1.185-.16.276a7.913,7.913,0,0,1-1.488,1.8,8.68,8.68,0,0,1-1.643,1.17,12.059,12.059,0,0,1-3.9,1.309c-.509.084-1.021.14-1.535.179-.475.037-.95.034-1.425.034-.6,0-1.2-.042-1.8-.1a19.021,19.021,0,0,1-2.738-.477,19.335,19.335,0,0,1-3-1.008,18.7,18.7,0,0,1-3.435-1.943c-.468-.336-.918-.693-1.36-1.061l-.04-.036-.013-.175c.189-.224.38-.446.569-.67l1.172-1.382L233,28.714c.253-.3.5-.6.758-.895.21-.238.146-.215.366-.039a18.5,18.5,0,0,0,2.218,1.542,14.971,14.971,0,0,0,2.139,1.055,11.413,11.413,0,0,0,2.566.679c.368.053.739.088,1.11.113a9.442,9.442,0,0,0,.981.017,5.781,5.781,0,0,0,2.632-.665,3.13,3.13,0,0,0,1.365-1.454,1.569,1.569,0,0,0,.135-.564,2.638,2.638,0,0,0,.01-.5c-.013-.111-.02-.178-.02-.178l-.008-.1a4.951,4.951,0,0,0-.239-1.068,9.707,9.707,0,0,0-.977-2.072,8.192,8.192,0,0,0-1.318-1.648c-.15-.146-.3-.289-.462-.424a7.347,7.347,0,0,0-.68-.517c-.612-.4-1.24-.778-1.839-1.2l-.158-.1s-.029-.025-.124-.095a14.7,14.7,0,0,1-1.158-.945c-.286-.258-.551-.531-.808-.814a9.92,9.92,0,0,1-.865-1.147,5.2,5.2,0,0,1-.65-1.49l0-.089.046.079a1.875,1.875,0,0,0,.354.48,3.608,3.608,0,0,0,1.01.693,9.952,9.952,0,0,0,1.279.518c.53.181,1.067.341,1.607.49.517.144,1.038.275,1.558.414l.1.023.056.013.05.015.123.028c.846.217,1.688.45,2.514.734a21.049,21.049,0,0,1,2.2.885,11.388,11.388,0,0,1,1.488.823,8.929,8.929,0,0,1,1.062.83,7.176,7.176,0,0,1,1.257,1.511,6.228,6.228,0,0,1,.7,1.642,8.472,8.472,0,0,1,.273,1.63,11.526,11.526,0,0,1,.015,1.456,9.116,9.116,0,0,1-.461,2.493,7.011,7.011,0,0,1-.423,1.015",
    transform: "translate(-101.652 -7.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M246.011,19.565a5.145,5.145,0,0,1,.442,1.229l-.05-.023a2.322,2.322,0,0,0-.847-.987,6.3,6.3,0,0,0-1.268-.664,22.5,22.5,0,0,0-2.393-.793c-.826-.236-1.665-.424-2.5-.646-.63-.169-1.257-.355-1.876-.563l-.189-.062-.13-.046c-.218-.08-.438-.155-.655-.237a15.127,15.127,0,0,1-2.1-.941,7.7,7.7,0,0,1-2.656-2.389,6.23,6.23,0,0,1-.871-2.039,9.917,9.917,0,0,1-.248-1.66c-.028-.392-.023-.784-.02-1.176a5.849,5.849,0,0,1,.061-.778c.017-.119.02-.162.022-.162l.006-.057.017-.106c.021-.144.047-.287.076-.43a7.851,7.851,0,0,1,1.748-3.594A8.794,8.794,0,0,1,235,1.467,11.168,11.168,0,0,1,238.67.208c.438-.073.879-.124,1.321-.159a13.728,13.728,0,0,1,1.545-.043c.515.016,1.03.043,1.543.094a18.676,18.676,0,0,1,2.333.375,17.109,17.109,0,0,1,5.26,2.176,16.887,16.887,0,0,1,1.436,1.007l.063.049.016.116-.136.2q-.9,1.281-1.8,2.563c-.16.228-.321.457-.481.686l-.044.063-.039.054-.041.05-.032.049-.106.154q-.306.441-.616.882l-.039.054-.134.027-.167-.112c-.1-.061-.106-.069-.106-.069l-.025-.017L248.4,8.39l-.056-.037L248.27,8.3c-.43-.282-.869-.548-1.321-.794a16.45,16.45,0,0,0-2.6-1.171,10.1,10.1,0,0,0-3.227-.578,7.142,7.142,0,0,0-1.4.113,3.745,3.745,0,0,0-1.6.684,2.194,2.194,0,0,0-.758,1.007,3.829,3.829,0,0,0-.206,1.089,4.168,4.168,0,0,0,.226,1.564,10.084,10.084,0,0,0,1.065,2.207,8.594,8.594,0,0,0,1.906,2.106l.111.085.137.1s.188.135.286.2c.554.358,1.113.711,1.664,1.075a12.854,12.854,0,0,1,1.622,1.286,9.494,9.494,0,0,1,1.62,1.935",
    transform: "translate(-101.889 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M311.542,71.9h-1.484v8.878h1.484v-1a2.623,2.623,0,0,0,2.189,1.129,3.072,3.072,0,0,0,2.98-3.331v-.026a3.073,3.073,0,0,0-2.98-3.332,2.574,2.574,0,0,0-2.189,1.2Zm1.837,7.735a1.935,1.935,0,0,1-1.872-2.054v-.026a1.935,1.935,0,0,1,1.872-2.054,1.908,1.908,0,0,1,1.837,2.054v.026a1.88,1.88,0,0,1-1.837,2.054",
    transform: "translate(-136.969 -31.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M330.2,76.3h-1.532l-1.679,4.768-1.8-4.768H323.6l2.676,6.434c-.243.548-.5.73-.912.73a1.8,1.8,0,0,1-.863-.244l-.5,1.084a2.927,2.927,0,0,0,1.52.4c1.035,0,1.607-.487,2.117-1.813Z",
    transform: "translate(-142.953 -33.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M345.305,66.333h-4.843a.882.882,0,0,1,.443.858V77.514a.949.949,0,0,1-.443.884h2.767a.948.948,0,0,1-.442-.884v-10.3h2.1a2.215,2.215,0,0,1,2.076,2.408,2.3,2.3,0,0,1-2.187,2.408h-.8l3.6,5.258a2.241,2.241,0,0,0,1.938,1.106h1.024L346.494,72.5a3.241,3.241,0,0,0,2.6-2.988c0-1.744-1.661-3.183-3.791-3.183",
    transform: "translate(-150.4 -29.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M363.878,69.852h-2.546a.8.8,0,0,1,.36.747v8.634a.784.784,0,0,1-.36.721h2.546a.919.919,0,0,1-.359-.721V70.6a.859.859,0,0,1,.359-.747",
    transform: "translate(-159.619 -30.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M378.661,69.8h-1.439a.349.349,0,0,1,.111.248l-.028.166-2.795,6.671-2.629-6.338a1.211,1.211,0,0,0-1.107-.72h-1.162l4.427,10.711,4.29-10.267a1.445,1.445,0,0,1,.332-.471",
    transform: "translate(-163.277 -30.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M394.49,69.852h-6.338a.872.872,0,0,1,.443.747v9.355l6.309-.028V78.349a1.4,1.4,0,0,1-1.229.721l-.071,0h-3.183V75.194h2.629a.619.619,0,0,1,.581.332V73.949a.645.645,0,0,1-.581.358h-2.629V70.738h2.8a1.244,1.244,0,0,1,1.274.747Z",
    transform: "translate(-171.467 -30.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M408.575,69.852h-4.262a.859.859,0,0,1,.36.747v8.607a.778.778,0,0,1-.36.719h2.546a.916.916,0,0,1-.36-.719v-8.5h1.6a1.968,1.968,0,0,1,0,3.93h-.747l3.072,4.4a2.1,2.1,0,0,0,1.743.915h1.08l-3.376-4.817a2.922,2.922,0,0,0,2.131-2.6c0-1.44-1.383-2.685-3.432-2.685",
    transform: "translate(-178.606 -30.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M431.678,66.284h-7.139a1.007,1.007,0,0,1,.442.886V77.493a1.077,1.077,0,0,1-.442.885h2.74a.952.952,0,0,1-.443-.885v-4.9h3.072a.825.825,0,0,1,.72.416V71.238a.826.826,0,0,1-.72.415h-3.072v-4.4h3.32a1.476,1.476,0,0,1,1.522.886Z",
    transform: "translate(-187.541 -29.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M445.111,69.852h-4.262a.859.859,0,0,1,.36.747v8.607a.841.841,0,0,1-.36.719H443.4a.915.915,0,0,1-.361-.719v-8.5h1.606a1.968,1.968,0,0,1,0,3.93h-.747l3.072,4.4a2.1,2.1,0,0,0,1.742.915h1.081l-3.376-4.817a2.921,2.921,0,0,0,2.131-2.6c0-1.44-1.384-2.685-3.432-2.685",
    transform: "translate(-194.746 -30.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M464.431,69.406a5.313,5.313,0,0,0-.005,10.627h.055a5.313,5.313,0,0,0,0-10.626Zm.161,9.714c-2.3,0-3.459-2.739-3.459-4.676,0-2.354,1.383-4.152,3.1-4.152,2.3,0,3.487,2.74,3.459,4.678,0,2.351-1.383,4.151-3.1,4.151",
    transform: "translate(-202.826 -30.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M491.206,69.852h-1.688a.858.858,0,0,1,.359.747v6.116L483.6,69.852h-2.048a.821.821,0,0,1,.388.747v8.634a.873.873,0,0,1-.388.721h1.688a.782.782,0,0,1-.359-.721v-7.5l7.942,8.745V70.6a.884.884,0,0,1,.387-.747",
    transform: "translate(-212.725 -30.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M510.44,69.852h-8.22v1.827a1.54,1.54,0,0,1,1.55-.886h1.661v8.413a.917.917,0,0,1-.36.719h2.518a.816.816,0,0,1-.332-.719V70.793h1.66a1.471,1.471,0,0,1,1.522.913Z",
    transform: "translate(-221.857 -30.857)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiversharesLogoLight);
export default __webpack_public_path__ + "static/media/rivershares_logo_light.d2f3be40164598e3aa800e81f3d22099.svg";
export { ForwardRef as ReactComponent };